export default {
  // 入场时间段配置
  insertWlVehicleTimeslot: '/ygsjzs/wlVehicleTimeslot/insertWlVehicleTimeslot',
  updateWlVehicleTimeslot: '/ygsjzs/wlVehicleTimeslot/updateWlVehicleTimeslot',
  deleteDataWlVehicleTimeslot: '/ygsjzs/wlVehicleTimeslot/deleteDataWlVehicleTimeslot',
  selectWlVehicleTimeslotBySlotId: '/ygsjzs/wlVehicleTimeslot/selectWlVehicleTimeslotBySlotId',
  selectWlVehicleTimeslotByPage: '/ygsjzs/wlVehicleTimeslot/selectWlVehicleTimeslotByPage',
  selectWlVehicleTimeList: '/ygsjzs/wlVehicleTimeslot/selectWlVehicleTimeList',
  // 入场计划
  insertWlVehiclePlan: '/ygsjzs/wlVehiclePlan/insertWlVehiclePlan',
  editWlVehiclePlan: '/ygsjzs/wlVehiclePlan/editWlVehiclePlan',
  editMwWlVehiclePlan: '/ygsjzs/wlVehiclePlan/editMwWlVehiclePlan',
  updateWlVehiclePlan: '/ygsjzs/wlVehiclePlan/updateWlVehiclePlan',
  deleteDataWlVehiclePlan: '/ygsjzs/wlVehiclePlan/deleteDataWlVehiclePlan',
  selectWlVehiclePlanByPlanId: '/ygsjzs/wlVehiclePlan/selectWlVehiclePlanByPlanId',
  selectWlVehiclePlanByPage: '/ygsjzs/wlVehiclePlan/selectWlVehiclePlanByPage',
  selectWlVehicleDayByList2: '/ygsjzs/wlVehiclePlan/selectWlVehicleDayByList2',
  editWlVehiclePlanQx: '/ygsjzs/wlVehiclePlan/editWlVehiclePlanQx',
  // 确认车辆出场
  editMwWlVehiclePlanCc: '/ygsjzs/wlVehiclePlan/editMwWlVehiclePlanCc',
  // 计划配置
  insertWlVehicleDate: '/ygsjzs/wlVehicleDate/insertWlVehicleDate',
  updateWlVehicleDate: '/ygsjzs/wlVehicleDate/updateWlVehicleDate',
  deleteDataWlVehicleDate: '/ygsjzs/wlVehicleDate/deleteDataWlVehicleDate',
  selectWlVehicleDateByDateId: '/ygsjzs/wlVehicleDate/selectWlVehicleDateByDateId',
  selectWlVehicleDateByPage: '/ygsjzs/wlVehicleDate/selectWlVehicleDateByPage',
  // 订餐统计
  selectWlVehicleMealByList: '/ygsjzs/wlVehiclePlan/selectWlVehicleMealByList',
  // 查询车辆入场的规格清单
  selectWlVehiclePlanGg: '/ygsjzs/wlVehiclePlan/selectWlVehiclePlanGg'
}
